import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { STATUS_TYPE } from './constants';
export var getDefaultStyleSheet = _ref => {
  var {
    designContext,
    disabled,
    hasCheckbox,
    hasUntruncatedDescription,
    hasUntruncatedTitle,
    noIcon,
    itemThumbnailUri,
    itemThumbnailBackgroundColor,
    statusType,
    valueSuccess
  } = _ref;
  return {
    rootStyle: {
      position: 'relative',
      // Android fix
      // https://github.com/facebook/react-native/issues/6802
      marginLeft: -20,
      paddingLeft: 20,
      paddingRight: 20,
      marginRight: -20
    },
    headerStyle: {
      minHeight: 40,
      paddingLeft: noIcon ? 0 : itemThumbnailUri !== undefined ? 65 : 55
    },
    headerInnerStyle: {
      flexDirection: 'column',
      justifyContent: 'center'
    },
    descriptionWithStatusStyle: {},
    avatarWrapperStyle: {
      position: 'absolute',
      opacity: disabled ? 0.5 : 1,
      left: 20,
      top: itemThumbnailUri ? 10 : 15,
      backgroundColor: itemThumbnailBackgroundColor || designContext.get('colors/backgrounds/transparent').toString()
    },
    titleSuffixStyle: _objectSpread({}, designContext.get('transaction/title-suffix-text-style').styles()),
    touchableStyle: _objectSpread(_objectSpread({
      backgroundColor: designContext.get('colors/backgrounds/transparent').toString(),
      border: '0',
      outline: 'none'
    }, disabled ? {} : {
      cursor: 'pointer'
    }), {}, {
      width: '100%'
    }),
    contentWrapperStyle: {
      flexDirection: 'row'
    },
    titleAndValueWrapper: _objectSpread({
      flexDirection: 'row',
      justifyContent: 'space-between'
    }, hasCheckbox ? {
      paddingRight: 45
    } : {}),
    transactionContentWrapper: {
      flexGrow: 1
    },
    transactionCheckmarkWrapperStyle: {
      position: 'absolute',
      right: 20,
      top: 21
    },
    titleWrapper: {
      flexShrink: 1
    },
    descriptionWrapper: _objectSpread({}, hasCheckbox ? {
      paddingRight: 45
    } : {}),
    valueWrapper: {
      paddingLeft: 5,
      flexGrow: 1,
      alignItems: 'flex-end'
    },
    // Status
    descriptionStyle: _objectSpread(_objectSpread({
      color: designContext.get('transaction/description-status-text-color', {
        interactiveState: disabled ? 'disabled' : 'default',
        descriptionStatusSuccessState: statusType === STATUS_TYPE.ERROR ? 'error' : statusType === STATUS_TYPE.WARNING ? 'warning' : statusType === STATUS_TYPE.SUCCESS ? 'success' : 'default'
      }).toString()
    }, designContext.get('transaction/description-text-style').styles()), {}, {
      textRendering: 'geometricPrecision',
      WebkitFontSmoothing: 'antialiased'
    }),
    // Value
    paragraphSecondaryCorrectFootprintMediumStyle: _objectSpread(_objectSpread({
      color: designContext.get('transaction/value-text-color', {
        interactiveState: disabled ? 'disabled' : 'default',
        valueSuccessState: valueSuccess ? 'success' : 'default'
      }).toString()
    }, designContext.get('transaction/value-text-style').styles()), {}, {
      marginTop: -3,
      paddingBottom: 5,
      paddingTop: 0,
      WebkitFontSmoothing: 'antialiased',
      textAlign: 'left',
      wordBreak: 'break-word',
      marginBottom: -10
    }),
    // Title
    paragraphSecondaryCorrectFootprintBlockMediumStyle: _objectSpread(_objectSpread(_objectSpread({
      color: designContext.get('transaction/title-text-color', {
        interactiveState: disabled ? 'disabled' : 'default'
      }).toString()
    }, designContext.get('transaction/title-text-style').styles()), {}, {
      marginTop: -5,
      WebkitFontSmoothing: 'antialiased',
      textAlign: 'left'
    }, !hasUntruncatedTitle && {
      maxWidth: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }), {}, {
      wordBreak: 'break-word',
      marginBottom: -10,
      paddingBottom: 5,
      paddingTop: 2
    }),
    // Description
    paragraphTertiaryCorrectFootprintEllipsisStyle: _objectSpread(_objectSpread(_objectSpread({
      color: designContext.get('transaction/description-text-color', {
        interactiveState: disabled ? 'disabled' : 'default'
      }).toString()
    }, designContext.get('transaction/description-text-style').styles()), {}, {
      marginTop: -3,
      textRendering: 'geometricPrecision',
      WebkitFontSmoothing: 'antialiased',
      textAlign: 'left'
    }, !hasUntruncatedDescription && {
      maxWidth: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }), {}, {
      wordBreak: 'break-word',
      marginBottom: -10,
      paddingBottom: 5,
      paddingTop: 0
    })
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map